import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  AfterViewInit,
  PLATFORM_ID,
  Inject,
} from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { DataService } from "../../../@core/services/data.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ContactFormWithMapInterface } from "../../../@core/models/site-data.model";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GoogleAnalyticsService } from "../../../@core/services/google-analytics.service";
import { AnalyticsService } from "../../../@core/services/analytics.service";
import * as Sentry from "@sentry/browser";
import { SocialNetworksModel } from "../../../@core/models/social-networks.model";
import { FeatureModel } from "../../../@core/models/feature.model";
import { isPlatformBrowser } from "@angular/common";


declare let L: any;
@Component({
  selector: "app-contact-form-with-map",
  templateUrl: "./contact-form-with-map.component.html",
  styleUrls: ["./contact-form-with-map.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialContactFormWithMapComponent implements OnInit, AfterViewInit, OnDestroy {

  contactFormGroup: FormGroup;
  title: string;
  textColor: string = '';
  backgroundColor: string = '';
  titleSize: string;
  textSize: string;
  activatePadding: boolean = false;
  socialNetworks: SocialNetworksModel = {};
  text: string;
  conversionLabel: string;
  // tslint:disable-next-line:max-line-length
  consentText =
    "By clicking the button bellow, you hereby acknowledge that we will process your personal information in accordance with our";
  buttonText: string = "Get Started";
  mailChimpId: string;
  subscription: Subscription;
  errorMessage: string;
  data: ContactFormWithMapInterface;
  active: boolean = false;
  classBuilder: string = "";
  position: number = 0;
  moduleInfo: string;
  displayNetworks: boolean;
  editOn: boolean = false;
  textAlign: string = "";
  features: FeatureModel[] = [];
  privacyPolicyExist: boolean = false;
  privacyPolicyLink: string = '';
  lat: number;
  lng: number;
  mapTimer: any;
  nameFieldName: string = '';
  addressFieldName: string = '';
  messageFieldName: string = '';
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingData$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  allElementAnimation: string;
  textAnimation: string;
  formAnimation: string;


  constructor(
    private dataService: DataService,
    private analyticsService: AnalyticsService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    @Inject(PLATFORM_ID) public platformId,
    private dialog: MatDialog
  ) { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.mapTimer = setTimeout(this.LoadLeaflet.bind(this), 500);
    }
  }
  LoadLeaflet() {
    if (this.lat && this.lng && window.document.getElementById('global-contact-map-container-' + this.position)) {
      window.document.getElementById('global-contact-map-container-' + this.position).innerHTML = '';
      window.document.getElementById('global-contact-map-container-' + this.position).innerHTML = `<div class="mapcontainer" id="mapContact-${this.position}"></div>`;
      const url = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
      if (!window.document.querySelector(`script[src='${url}']`)) {
        let script = window.document.createElement('script');
        script.src = url;
        window.document.body.appendChild(script);
        let link = window.document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
        window.document.body.appendChild(link);
      }
      if (window.document.getElementById('mapContact-' + this.position) && this.lat && this.lng) {
        setTimeout(this.LoadMap.bind(this), 2000);
      } else {
        this.mapTimer = setTimeout(this.LoadLeaflet.bind(this), 500);
      }
    } else {
      this.mapTimer = setTimeout(this.LoadLeaflet.bind(this), 500);
    }
  }
  LoadMap() {
    try {
      let buttonOverlay = '';
      if (this.data.address) {
        buttonOverlay = buttonOverlay + `<div style="font-size:15px;font-weight: 500;margin-top: 20px;"><div style="font-size:14px;"><i style="vertical-align: sub;color: #e91e63; font-size: 17px ​!importan;" class="features-material-icons-small material-icons">location_on</i>${this.data.address}</div></div>`
      }
      if (this.data.email) {
        buttonOverlay = buttonOverlay + `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;font-size: 17px ​!importan;" class="features-material-icons-small material-icons"> email </i>${this.data.email}</div></div>`
      }
      if (this.data.phone) {
        buttonOverlay = buttonOverlay + `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;color: green; font-size: 17px ​!importan;" class="features-material-icons-small material-icons"> call </i>${this.data.phone}</div></div>`
      }
      if (this.data.timetable) {
        buttonOverlay = buttonOverlay + `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;blue; font-size: 17px ​!importan;" class="features-material-icons-small material-icons">  schedule  </i>${this.data.timetable}</div></div>`
      }
      if (this.lat && this.lng) {
        var mymap = L.map('mapContact-' + this.position).setView([this.lat, this.lng], 14);
        var marker = L.marker([this.lat, this.lng]).addTo(mymap).bindPopup(buttonOverlay).openPopup();;
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          minZoom: 5,
          maxZoom: 18,
          attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>'
        }).addTo(mymap);
      }
    } catch (err) {
      const url = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
      if (!window.document.querySelector(`script[src='${url}']`)) {
        let script = window.document.createElement('script');
        script.src = url;
        window.document.body.appendChild(script);
        let link = window.document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
        window.document.body.appendChild(link);
      }
      setTimeout(this.LoadMap.bind(this), 2000);
    }
  }
  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "ContactFormComponent");
    });
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.formAnimation = this.data.animation.form != '' ? this.data.animation.form : undefined;

    }
    this.loadingData$.next(true);
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.initForm();
    this.title = this.data.title;
    this.text = this.data.text;
    this.textColor = this.data.textColor;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.textSize = this.data.textSize ? this.data.textSize : '';
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.textAlign = this.data.textAlign ? this.data.textAlign : '';
    this.nameFieldName = this.data.nameFieldName ? this.data.nameFieldName : 'Your Name';
    this.addressFieldName = this.data.addressFieldName ? this.data.addressFieldName : 'Email address';
    this.messageFieldName = this.data.messageFieldName ? this.data.messageFieldName : 'Your Message';
    this.lat = this.data.lat ? (typeof this.data.lat == 'string' ? Number(this.data.lat.trim()) : Number(this.data.lat)) : 40.7127281;
    this.lng = this.data.lng ? (typeof this.data.lng == 'string' ? Number(this.data.lng.trim()) : Number(this.data.lng)) : -74.0060152;
    this.displayNetworks = this.data.displayNetworks ? this.data.displayNetworks : false;
    if (this.data.consentText !== '' || this.data.consentText !== null) {
      this.consentText = this.data.consentText;
    }
    this.conversionLabel = this.data.conversionLabel;
    this.buttonText = this.data.buttonText;
    this.subscription = this.dataService.getCurrentSite().subscribe(site => {
      if (site) {
        this.privacyPolicyExist = site.privacyPolicy ? true : false;
        this.privacyPolicyLink = "https://" + (site.domainName ? site.domainName : site.siteUrl) + '/privacy-policy';
        if (this.displayNetworks) {
          if (site && site.socialMedia) {
            site.socialMedia.forEach(element => {
              if (element.link) {
                this.socialNetworks[element.network] = element.link;
              }
            });
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  initForm(): void {
    this.contactFormGroup = this.fb.group({
      name: ["", Validators.required],
      email: ["", Validators.compose([Validators.email, Validators.required])],
      message: ["", Validators.required],
      consent: [false], // ,Validators.required]
    });
  }

  isFormInvalid(): boolean {
    const controls = this.contactFormGroup.controls;
    if (controls["consent"].value === true && this.contactFormGroup.valid) {
      this.errorMessage = undefined;
      return false;
    } else if (this.contactFormGroup.dirty && this.contactFormGroup.invalid) {
      this.errorMessage = "Please fill in all the required fields.";
      return true;
    } else if (
      this.contactFormGroup.dirty &&
      this.contactFormGroup.valid &&
      controls["consent"].value === false
    ) {
      this.errorMessage =
        "Please read and agree to our privacy policy by checking the box.";
      return true;
    } else {
      return true;
    }
  }


  submitForm() {
    this.subscription = this.dataService.getCurrentSite().subscribe(site => {
      const body = {
        message: this.contactFormGroup.get('message').value,
        email: this.contactFormGroup.get('email').value,
        userName: this.contactFormGroup.get('name').value,
        subject: 'Contact message on ' + window.location.hostname,
        siteId: site.siteId,
        siteUrl: site.siteUrl,
        emailSiteOwner: site.email,
      };
      this.loading$.next(true);
      this.dataService.postcontactUs(body).subscribe(res => {
        this.initForm();
        this.loading$.next(false);
        const currentSite = this.dataService.site$.getValue();
        this._snackBar.open("Thanks for your interest. We'll get back to you soon!", '', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['info-snackbar']
        });
        if (currentSite) {
          this.analyticsService.trackConversion(currentSite, 'conversion');
        }
        if (currentSite.googleAnalyticsPixel) {
          this.googleAnalyticsService.eventEmitter('contact_us', 'contact_us', 'contact_us' + this.contactFormGroup.get('email').value, 'contact');
        }
        if (currentSite.facebookPixel) {
          this.googleAnalyticsService.FbEventEmitter('Contact', 'contact', 'Contact ', 'contact_us');
        }
        if (currentSite.googleAdwordsPixel && this.conversionLabel) {
          this.googleAnalyticsService.AdsEventEmitter(`${currentSite.googleAdwordsPixel.conversionID}/${this.conversionLabel}`, 'contact_us', 'contact_us');
        }
      }, err => {
        this.loading$.next(false);
        this._snackBar.open(err.error.message, '', {
          duration: 5 * 1000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['danger-snackbar']
        });
      });
    });
  }
  setConsentChecked() {
    this.contactFormGroup.controls['consent'].setValue(!this.contactFormGroup.controls['consent'].value);
  }
  isSocialMediaExist() {
    if (!this.socialNetworks.facebook && !this.socialNetworks.instagram && !this.socialNetworks.linkedin && !this.socialNetworks.pinterest && !this.socialNetworks.snapchat && !this.socialNetworks.twitter && !this.socialNetworks.vkontakte && !this.socialNetworks.youtube) {
      return false;
    } else {
      return true;
    }
  }
}
